var _polygon, _polygon2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSabeqoonIconColored11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.48 39.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21.04 27.42 22.89 20.8 27.26 23.27 22.08 27.42 21.04 27.42",
    fill: "#fcb814",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.55 7.72 33.48 5.65 36.59 1.5 36.97 .92 39.7 1.5 40.74 2.54 40.74 4.61 37.81 7.9 37.63 8.76 35.55 7.72",
    fill: "#eb1470",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.31,13.13h18.01c.41,0,.73-.34.72-.75,0-.4-.33-.72-.72-.72H7.31c-.41,0-.73.34-.72.75,0,.4.33.71.72.72Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31,18.74h11.09c.41,0,.73-.34.72-.75,0-.4-.33-.72-.72-.72H7.31c-.41,0-.73.34-.72.75,0,.39.33.71.72.72h0Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.63,22.87H7.31c-.41,0-.74.33-.74.74s.33.74.74.74h11.33c.41,0,.73-.34.72-.75,0-.4-.33-.71-.72-.72Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.95,28.47H7.31c-.41,0-.73.35-.72.75,0,.39.33.71.72.72h9.65c.41,0,.73-.34.72-.75,0-.4-.33-.71-.72-.72Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44,3.25c-.1-.56-.42-1.06-.89-1.39l-2.13-1.48c-.98-.68-2.32-.43-3,.54l-2.82,4.06c-.08-1.58-1.38-2.82-2.96-2.83H2.98c-1.64,0-2.97,1.33-2.98,2.98v31.33c0,1.64,1.33,2.97,2.98,2.98h26.67c1.64,0,2.97-1.33,2.98-2.98v-19.41c1.97-2.83,6.55-9.44,8.47-12.21.33-.47.45-1.05.35-1.61ZM31.15,36.47c0,.83-.67,1.5-1.51,1.51H2.98c-.83,0-1.5-.67-1.51-1.51V5.14c0-.83.67-1.5,1.51-1.51h26.67c.83,0,1.5.67,1.51,1.51v1.95l-8.89,12.82c-.04.08-.07.15-.11.23l-1.91,7.36c-.1.4.15.8.55.89.2.05.41.01.58-.1l6.36-4.26c.08-.07.15-.14.22-.22l3.22-4.64v17.28ZM23.31,21.53l2.7,1.88-3.86,2.59,1.16-4.46ZM27.14,22.4l-3.25-2.25,9.22-13.29,3.25,2.25-9.22,13.29ZM39.89,4.02l-2.69,3.88-3.25-2.25,2.69-3.88c.22-.31.64-.39.95-.17l2.13,1.48c.31.22.39.64.17.95h0Z",
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabeqoonIconColored11);
export default __webpack_public_path__ + "static/media/Sabeqoon_Icon_Colored_11.a110e8977a5cc8fc4fdbceb3a9ba8475.svg";
export { ForwardRef as ReactComponent };